import { render } from "./MembershipTypeForm.vue?vue&type=template&id=bfb931a2"
import script from "./MembershipTypeForm.vue?vue&type=script&lang=js"
export * from "./MembershipTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QCheckbox,QBtn,QEditor});
